import { useNavigate } from "react-router-dom";
import { AppRoute } from "../../shared/oversight-core/interfaces/app-routes";
import LoginLayout from "../../shared/oversight-core/shared-components/login-layout/login-layout";
import LoginForm from "./login-form/login-form";

const Login = () => {
  const navigate = useNavigate();

  return (
    <LoginLayout
      title="Login to Your Account"
      showBackButton
      onBack={() => {
        navigate(AppRoute.PUBLIC_DESIGN_SYSTEM);
        localStorage.removeItem("advancedSave");
        localStorage.removeItem("redirect");
      }}
    >
      <LoginForm />
    </LoginLayout>
  );
};

export default Login;
